import { render, staticRenderFns } from "./TripDetailsRoom.vue?vue&type=template&id=b4ad5996&scoped=true"
import script from "./TripDetailsRoom.vue?vue&type=script&lang=js"
export * from "./TripDetailsRoom.vue?vue&type=script&lang=js"
import style0 from "./TripDetailsRoom.vue?vue&type=style&index=0&id=b4ad5996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ad5996",
  null
  
)

export default component.exports